import { manufacturers } from '@/mocks/homeData';

export default function ManufacturersSection() {
  return (
    <section id="manufacturers" className="relative py-20 md:py-28 bg-background-900/40">
      <div className="section-padding max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-14 md:mb-20 reveal">
          <p className="text-primary-400 text-xs font-semibold tracking-[0.25em] uppercase mb-4">
            Our Network
          </p>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-50 mb-4">
            Trusted Manufacturers
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            OEM, OE, and aftermarket parts — across engines, hydraulics, filtration, and industrial systems.
          </p>
        </div>

        {/* Manufacturers Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5 reveal">
          {manufacturers.map((mfr, index) => (
            <div
              key={mfr.id}
              className="group flex items-center justify-center p-5 md:p-6 bg-background-900 border border-background-800/50 rounded-xl hover:border-primary-500/30 hover:bg-background-800/50 transition-all duration-500"
              style={{ animationDelay: `${index * 50}ms` }}
            >
              <span className="text-sm md:text-base font-bold text-foreground-300 group-hover:text-primary-400 transition-colors duration-300 text-center tracking-wide whitespace-nowrap">
                {mfr.name}
              </span>
            </div>
          ))}

          {/* Plus more card */}
          <div className="flex items-center justify-center p-5 md:p-6 bg-primary-500/5 border border-primary-500/20 rounded-xl">
            <div className="text-center">
              <p className="text-lg md:text-xl font-bold text-primary-400 font-heading">100+</p>
              <p className="text-xs text-foreground-400 mt-1">more manufacturers</p>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <p className="text-center text-xs text-foreground-600 mt-10 max-w-2xl mx-auto">
          Brand and Manufacturer Names are used solely for identification and compatibility. Avenor Meridian is an Independent Supplier.
        </p>
      </div>
    </section>
  );
}